import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, DropdownButton } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useOutletContext } from 'react-router-dom';
import moment from 'moment';
//icons
import { AiOutlineEye } from 'react-icons/ai';
import { FiExternalLink } from "react-icons/fi";
//api
import { deleteSlider } from 'api/sliders';
import { getAllSliders } from 'api/pathForHook/products';
//constants
import { choicesSliderCategories } from 'constants';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import Title from 'components/backoffice/texts/title';
import Button from 'components/backoffice/buttonCustom';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import CustomTable from 'components/backoffice/customTable';
import { SelectInputCustom } from 'components/input/index';
import SearchTable from 'components/backoffice/table/SearchTable';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import WatchModal from 'components/backoffice/modals/WatchModal';
import { usePermissions } from 'components/backoffice/PermissionsContext';
import SliderModal from './modals/sliderModal';

const SlidersPage = () => {
  const userPermissions = usePermissions();
  const { t } = useTranslation(['backoffice']);
  const [sliders, setSliders] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [typeAction, setTypeAction] = useState('create');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [slider, setSlider] = useState({});
  const [page, setPage] = useState(1);
  const [openModalImage, setOpenModalImage] = useState(false);
  const [sliderToShow, setSliderToShow] = useState({});
  const [responseInfo, setResponseInfo] = useState({});
  const { setTitle } = useOutletContext()

  const colsSliders = [t('category'), `${t('producto')} / ${t('externalLink')}`, t('frontpage'), t('creationdate'), t('activo'), t('actions')];

  const { fetchData, stateData, loading } = useHandleSearch();

  const sliderCategories = choicesSliderCategories(t);

  const getListSliders = async () => {
    try {
      const payload = {
        page,
        page_size: 10,
        type_str: inputValue,
        fields: 'id,type_str,product,portada,fecha,active,outer_url',
      };
      await fetchData(getAllSliders(), payload);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setTitle(t('sliders'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setSliders(results);
      setResponseInfo({ errors, totalPages, noResults });
    } else {
      setSliders(null);
      setResponseInfo({ errors });
    }
  }, [stateData]);

  useEffect(() => {
    if (page > 1 && inputValue !== '') {
      setPage(1);
    }
  }, [inputValue])

  useEffect(() => {
    getListSliders();
  }, [page, inputValue]);

  const onDelete = async () => {
    const { status } = await deleteSlider(slider.id);
    if (status === 204) {
      toast.success(t('eliminadocorrectamente'));
      getListSliders();
      setShowDeleteModal(false);
    }
  };

  const handleClear = () => {
    setInputValue('');
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, totalPages: responseInfo?.totalPages }));
  };

  const openModalDelete = (object) => {
    setShowDeleteModal(true);
    setSlider(object);
  };

  const openModalUpdate = (object) => {
    setShowModal(true);
    setTypeAction('edit');
    setSlider(object);
  };

  const openModalCreate = () => {
    setShowModal(true);
    setTypeAction('create');
    setSlider({});
  };

  const onSuccess = () => {
    setPage(1);
    getListSliders();
  };

  const handleWatchItem = (slider) => {
    const transformedItem = {
      ...slider,
      image: slider.portada,
    };
    setSliderToShow(transformedItem);
    setOpenModalImage(true);
  };

  return (
    <div className="d-lg-grid">
      <Title text={t('sliders')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={5} xs={12} className="d-flex text-start">
          <SearchTable
            handleClear={handleClear}
            typeselect={true}
            className="d-flex align-items-center "
          >
            <SelectInputCustom
              choices={sliderCategories}
              value={inputValue}
              onCheckedItem={setInputValue}
              className="input-control"
            />
          </SearchTable>
        </Col>
        <Col md={7} xs={12} className="d-flex text-end align-bottom p-md-0 justify-content-end pt-5 pt-md-0">
          {userPermissions.includes('sliderclient.__add') && (
            <Button color={'primary'} onClick={openModalCreate}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsSliders}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {sliders?.length > 0 &&
            sliders?.map((slider) => {
              const fechaFormateada = moment(slider.fecha).format('DD[/]MM[/]YYYY');
              return (
                <tr key={slider.id}>
                  <td className="text-light">{t(slider.type_str)}</td>
                  <td className="text-light" title={!slider.product && slider.outer_url}>
                    {slider.product ? slider.product.title :
                      <a
                        className='d-flex flex-row align-items-center text-link-slider'
                        href={slider.outer_url}
                        target="_blank"
                        rel="noopener noreferrer">
                        <FiExternalLink className='me-1' />
                        <span className='mt-1'>{t('link')}</span>
                      </a>}
                  </td>
                  <td className="text-light item-dropdown text-start">
                    <DropdownButton title={<AiOutlineEye color="white" />} onClick={() => handleWatchItem(slider)} />
                  </td>
                  <td>{fechaFormateada}</td>
                  <td>{slider.active ? t('si') : t('no')}</td>
                  <td className="text-light item-dropdown text-end">
                    <DropdownIcons
                      idItem={slider.id}
                      handleDelete={
                        userPermissions.includes('sliderclient.__delete') && (() => openModalDelete(slider))
                      }
                      handleEdit={userPermissions.includes('sliderclient.__modify') && (() => openModalUpdate(slider))
                      }
                    />
                  </td>
                </tr>
              );
            })}
          {openModalImage && (
            <WatchModal
              idGallery={sliderToShow?.id}
              title={t('slider')}
              item={sliderToShow}
              show={openModalImage}
              setShow={setOpenModalImage}
              size="lg"
              beforeTitle={t('sliders')}
            />
          )}
        </CustomTable>
      </div>
      {showModal && (
        <SliderModal
          onUpdateTable={onSuccess}
          show={showModal}
          setShow={setShowModal}
          type={typeAction}
          sliders={sliders}
          object={slider}
        />
      )}
      <DeleteModalCustom
        name={slider?.titulo}
        openModal={showDeleteModal}
        setOpenModal={setShowDeleteModal}
        handleDelete={onDelete}
        deleteTitle={t('deleteslider')}
        beforeTitle={t('sliders')}
      />
    </div>
  );
};

export default SlidersPage;
